<template>
	<div class="page-content">
		<div class="inner-content">
			<section-dynamique-territoriale-end/>

			<!-- SECTION MARCHE LOCATIF PRIVE -->
			<div class="main-title">
				<p class="title dark_pink_text"><span class="no dark_pink_bg">{{ calc_index + 2 }}</span>Situation du marché locatif à {{ active_study.projet.adresse.ville | uppercase }}</p>
			</div>

			<section-situation-marche-locatif :index="calc_index + 2" editModeTheme="marche_locatif" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import SectionSituationMarcheLocatif from "@/components/study/editor/pages/sections/section-situation-marche-locatif";
import SectionDynamiqueTerritorialeEnd from "@/components/study/editor/pages/sections/section-dynamique-territoriale-end";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "page-situation",
	mixins: [ PageMixin ],
	data: function () {
		return {
			form: {
				
			}
		};
	},
	props: [ "index" ],
	computed: {
		...mapGetters([ "active_study" ]),
		calc_index: function () {
			if(this.active_study.etudeType.slug == "grand_projet")
				return this.index + 1;
			return this.index;
		}
	},
	components: {
		SectionSituationMarcheLocatif,
		SectionDynamiqueTerritorialeEnd
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

</style>
